import { helpers } from 'vuelidate/lib/validators';

export const hexColor = helpers.regex('hexColor', /^(?:[0-9a-fA-F]{3}){1,2}$/);
